import type { HouseholdMember } from '../services/householdService';

/** True when this transaction was uploaded by the signed-in user. */
export function isOwnTransaction(
  userId: string | null | undefined,
  viewerUserId: string | null | undefined,
): boolean {
  if (!viewerUserId || !userId) return false;
  return userId === viewerUserId;
}

/**
 * Light owner label for combined household spend lists.
 * Returns null when attribution is unnecessary (personal view / single member / missing id).
 */
export function resolveTransactionOwnerLabel(params: {
  userId?: string | null;
  view: 'personal' | 'combined';
  members: HouseholdMember[];
  memberCount: number;
  viewerUserId?: string | null;
}): string | null {
  const { userId, view, members, memberCount, viewerUserId } = params;
  if (view !== 'combined' || memberCount < 2 || !userId) return null;
  if (viewerUserId && userId === viewerUserId) return 'You';
  const member = members.find((m) => m.userId === userId);
  const name = member?.name?.trim();
  return name || 'Member';
}
